// Masraf dashboard'u renk sistemi (light yüzey; İzin Paneli'nde dataviz
// validator'dan geçirilmiş setlerin aynıları kullanılır).

// Kategorik slotlar — kategori kimliğine (id) stabil atanır, filtre değişince
// yeniden karılmaz. 7 kromatik slot + katlama nötrü (İzin Paneli'nde
// validate_palette.js --mode light PASS).
const CATEGORY_SLOTS = ['#2a78d6', '#eda100', '#4a3aa7', '#1baf7a', '#e87ba4', '#eb6834', '#008300'];
export const CATEGORY_FOLD_COLOR = '#898781';

// Görülen tüm kategorilerden stabil Map<categoryId, color> üretir (ada göre
// deterministik sırayla slot atanır; >7 kategori nötre katlanır).
export function buildCategoryColorMap(categories) {
  const map = new Map();
  const sorted = [...categories]
    .filter((c) => c && c.id)
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'tr'));

  let slot = 0;
  sorted.forEach((c) => {
    if (map.has(c.id)) return;
    map.set(c.id, slot < CATEGORY_SLOTS.length ? CATEGORY_SLOTS[slot] : CATEGORY_FOLD_COLOR);
    slot += 1;
  });
  return map;
}

// Proje renkleri — kategorilerle aynı 7 kromatik slot, projeye (id) stabil atanır: aynı
// proje halka, trend ve bütçe kartlarında hep aynı renkte görünür. Projesiz harcama ve
// "diğer projeler" katlaması renk değil nötr gri taşır.
export const PROJECT_UNASSIGNED_COLOR = '#C9CED6';
export const PROJECT_OTHER_COLOR = CATEGORY_FOLD_COLOR;
export const PROJECT_TOP_N = 5;

export function buildProjectColorMap(items) {
  const map = new Map();
  const sorted = [...(items || [])]
    .filter((p) => p && p.projectId)
    .sort((a, b) => (b.windowTotal || 0) - (a.windowTotal || 0) || (a.name || '').localeCompare(b.name || '', 'tr'));
  sorted.forEach((p, i) => {
    if (!map.has(p.projectId)) map.set(p.projectId, i < CATEGORY_SLOTS.length ? CATEGORY_SLOTS[i] : CATEGORY_FOLD_COLOR);
  });
  return map;
}

// Proje etiketi: "Ad (KOD)"; projesiz satır çevrilmiş etiketi alır.
export const projectLabel = (item, t) => (item?.projectId
  ? `${item.name}${item.code ? ` (${item.code})` : ''}`
  : t('expenseDashboard.projects.unassigned'));

// Giriş yoğunluğu ısı rampası (tek ton mavi; İzin Paneli'nde --ordinal PASS)
export const HEAT_RAMP = ['#86b6ef', '#5598e7', '#2a78d6', '#1c5cab', '#0d366b'];
export const HEAT_EMPTY = '#EEF1F5';

export function heatColor(count, maxCount) {
  if (!count || count <= 0) return HEAT_EMPTY;
  const max = Math.max(1, maxCount || 1);
  const idx = Math.min(HEAT_RAMP.length - 1, Math.floor(((count - 1) / max) * HEAT_RAMP.length));
  return HEAT_RAMP[idx];
}

// Durum paleti (renk asla tek başına anlam taşımaz — yazı/ikonla birlikte)
export const STATUS = {
  good: '#02D3BF',
  normal: '#0291EF',
  warning: '#FFC107',
  critical: '#E53935',
};

export const EXPENSE_STATUS_COLORS = {
  approved: '#2e7d32',
  rejected: '#d32f2f',
  canceled: '#9e9e9e',
  waiting: '#ed6c02',
};

export const KPI_ACCENTS = {
  total: '#2a78d6',
  count: '#1baf7a',
  pending: '#eda100',
  violation: '#E53935',
};

export const SEVERITY_COLORS = {
  critical: '#E53935',
  warning: '#eda100',
  info: '#898781',
};

// Bütçe kullanım bantları (gauge + şube kutuları)
export function budgetBand(pct) {
  if (pct >= 100) return STATUS.critical;
  if (pct >= 90) return STATUS.warning;
  return STATUS.normal;
}

// ₺ biçimleme — benefit-dashboard emsali (Intl tr-TR/TRY)
export const formatTry = (value, maximumFractionDigits = 0) =>
  new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits }).format(value || 0);

export const formatAmount = (value, currency) =>
  currency === 'TRY' || !currency
    ? formatTry(value)
    : `${Number(value || 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} ${currency}`;
